import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

const initialState = {
  isMobileOrTablet: false,
};

const layoutSlice = createSlice({
  name: "layoutSlice",
  initialState,
  reducers: {
    deviceIsMobileOrTablet: (state, action) => {
      state.isMobileOrTablet = action.payload;
    },
  }
})

export const { deviceIsMobileOrTablet } = layoutSlice.actions;

export const persistAppConfig = {
  version: 1,
  key: "mpg_next_admin_app_v1",
  storage,
  whitelist: ["layoutSlice"],
};

export default layoutSlice.reducer;
